import { render, staticRenderFns } from "./admin-users.vue?vue&type=template&id=c63c2776&"
import script from "./admin-users.vue?vue&type=script&lang=ts&"
export * from "./admin-users.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports